import 'array-flat-polyfill';
import { useState, useEffect } from 'react';
import { useFetch } from 'react-async';

import config from '../config';

const headers = { Accept: "application/json" }

export function useProducts(collection, search, filters = {}) {
     /* Declare URL */
     const url = `/shopify-store/${config.storeId}/products?collection=${collection}${search ? `&search=${search}` : ''}`;

     /* Filters */
     const filterParams = `${Object.entries(filters).map(([key, value]) => `&${key}=${value.join(',')}`).join('')}`;

     /* Build query params */
     const params = encodeURI(`${filterParams}`);

     /* Fetch data */
     const fetch = useFetch(`${config.backendUrl}${url}${params}`, { headers }, { json: true });

     /* Return our data */
     return {
          ...fetch,
          products: fetch.data ? fetch.data.products : [],
          filters: fetch.data ? fetch.data.filters : null,
          search,
     }
}
